module.exports = __webpack_public_path__ + "static/media/ie.2a2ffd03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/ie.svg
// module id = 1451
// module chunks = 0